/**
 * 基础菜单 域名管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>防封域名设置</el-breadcrumb-item>
    </el-breadcrumb>
    <el-form ref="editForm" :model="editForm" :rules="rules" label-width="80px" class="editForm">
      <el-form-item label="入口域名" prop="rukouName">
        <el-input v-model="editForm.rukouName" class="yuminginput" placeholder="例如: http://m.baiud.com"></el-input>
      </el-form-item>
      <p style="font-size: 0.875rem;padding-left: 5rem;color: #aaa;">你好，勿动，如需长期有效，建议绑定自有域名，有疑问请咨询客服</p>
      <el-form-item label="落地域名" prop="luodiName">
        <el-input v-model="editForm.luodiName" class="yuminginput" placeholder="例如: http://m.taobao.com"></el-input>
      </el-form-item>
      <p style="font-size: 0.875rem;padding-left: 5rem;color: #aaa;">你好，勿动，有疑问请咨询客服</p>
      <el-form-item>
        <el-button type="primary" @click="submitForm('editForm')">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getYuming, wxSave, ymSave } from '../../api/userMG'
export default {
  data() {
    return {
      loading: false, //是显示加载
      title: '添加',
      editForm: {
        rukouName: '',
        luodiName: ''
      },
      // rules表单验证
      rules: {
        rukouName: [
          { required: true, message: '请输入入口域名', trigger: 'blur' }
        ],
        luodiName: [
          { required: true, message: '请输入落地域名', trigger: 'blur' }
        ]
      }
    }
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取公司列表
    getdata() {
      this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      getYuming()
        .then(res => {
          console.log(res);
          this.loading = false
          if (res.code == 1) {
            this.editForm.rukouName = res.data['rukou'];
            this.editForm.luodiName = res.data['luodi'];
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('菜单加载失败，请稍后再试！')
        })
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          ymSave(this.editForm)
            .then(res => {
              this.loading = false
              if (res.code == 1) {
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.yuminginput {
  width: 30%;
}
.editForm {
  padding: 0.625rem;
  border: 1px solid #ccc;
  border-radius: 0.625rem;
  margin-top: 0.625rem;
}
</style>



// WEBPACK FOOTER //
// src/views/yuming/Yuming.vue